import toSelectOptions from './selectOptions';

describe('management/shared toSelectOptions', () => {
  it('renames value to the id KeyDS Select expects', () => {
    expect(toSelectOptions([{ label: 'Texas', value: 'TX' }])).toEqual([
      { id: 'TX', label: 'Texas' },
    ]);
  });

  // A phone country code arrives as a number. Left as one it would never match the
  // field's string value, and the option would silently never look selected.
  it('stringifies numeric values', () => {
    expect(toSelectOptions([{ label: '+52', value: 52 }])).toEqual([
      { id: '52', label: '+52' },
    ]);
  });

  it('tolerates a missing list', () => {
    expect(toSelectOptions()).toEqual([]);
  });
});
